import axios from "axios";

const authClient = axios.create({
    // Using process.env for Webpack/Vue-CLI
    baseURL: process.env.VUE_APP_AUTHENTICATION_URL
});

authClient.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            console.warn("Unauthorized - 401");
        }
        return Promise.reject(error);
    }
);

export default authClient;